import { render, staticRenderFns } from "./SupplierManufacturingHaccp.vue?vue&type=template&id=015d27b5&scoped=true&"
import script from "./SupplierManufacturingHaccp.vue?vue&type=script&lang=js&"
export * from "./SupplierManufacturingHaccp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015d27b5",
  null
  
)

export default component.exports